import React from 'react';
import { t, Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import { Body1 } from '@src/components/Typography';
import useSnackBar from '@src/hooks/useSnackBar';
import { i18n } from '@src/i18n';
import Clipboard from '@src/modules/Clipboard';
import { Discount } from '@src/types';

type Props = {
  data: Discount;
};

const Container = styled.View`
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const DiscountCard: React.FC<Props> = ({ data: { code, type, amount } }) => {
  const snackBar = useSnackBar();
  const handlePress = React.useCallback(() => {
    Clipboard.setString(code);
    snackBar.show({
      content: i18n._(t`Copied!`),
    });
  }, [code, snackBar]);

  return (
    <Container>
      <Body1>{code}</Body1>
      {type === 'PRICE' ? (
        <Body1>
          <Trans>{amount / 10000} thousand tomans code</Trans>
        </Body1>
      ) : type === 'PERCENT' ? (
        <Body1>
          <Trans>{amount} percent code</Trans>
        </Body1>
      ) : (
        <Body1>{amount}</Body1>
      )}

      <Button compact mode="outlined" onPress={handlePress}>
        <Trans>Copy</Trans>
      </Button>
    </Container>
  );
};

export default React.memo(DiscountCard);
